import * as React from 'react';

import { PrimaryButton } from '@longline/aqua-ui/controls/PrimaryButton';
import { Dialog } from '@longline/aqua-ui/services/Dialog';

import { IDriverset } from '../../../api/models';
import { Pane } from '../../../ui/Pane';
import { DriversetEditor } from '../../../ui/DriversetEditor';

interface IProps {
  onCancel: () => void;
  onSave: (driverset: IDriverset) => void;
}

const DriversetAdd = (props: IProps) => {
  const driversetRef = React.useRef<IDriverset>({ name: "New driver set", dates: [] });
  const [valid, setValid] = React.useState(false);
  
  const handleChange = (ds: IDriverset, isValid: boolean) => {
    Object.assign(driversetRef.current, ds);
    setValid(isValid);
  }

  // canClose={false}: an outside click would discard every edit without
  // asking, and the Excel import report renders inside this dialog, so
  // dismissing the report would count as clicking outside. The footer
  // buttons close it by calling their own handlers.
  return (
    <Dialog width={1200} inverted open={true} canClose={false} onClose={() => {}}>
      <Dialog.Header>
        Add Driverset
      </Dialog.Header>
      <Dialog.Content nopadding>
        <div style={{height:'500px', overflow: 'hidden', display: 'flex', flexDirection: 'column'}}>
          <DriversetEditor driverset={driversetRef.current} onChange={handleChange} withName/>
        </div>
      </Dialog.Content>
      <Dialog.Footer align='space-between'>
        <Pane.CancelButton onClick={props.onCancel}/>
        <PrimaryButton disabled={!valid} onClick={() => props.onSave(driversetRef.current)}>STORE</PrimaryButton>
      </Dialog.Footer>
    </Dialog>
  )
}

export { DriversetAdd }

